exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share-context{height:100%;background:#fff}.share-context .line{margin:10px 0;height:1px;width:100%;background-color:#ececec}.share-context .share-cancle{text-align:center}.share-context .share-tip{padding-top:5px;height:30px;line-height:30px;text-align:center}", ""]);

// exports
